module.exports = __webpack_public_path__ + "img/yam.0fbbcc15.jpeg";